import { EnumUtil } from '@/utils/libs/enumUtil';

export class TestIssueStatus extends EnumUtil {
  public static readonly CLOSED = 'Closed';
  public static readonly DUPLICATE = 'Duplicate';
  public static readonly FIXED = 'Fixed';
  public static readonly INVALID = 'Invalid';
  public static readonly NEW = 'New';
  public static readonly OPEN = 'Open';
  public static readonly REOPEN = 'Reopen';
}
